import {
    createSummaryTileComponent,
    SummaryTile,
} from '@vfde-brix/summary-tile';
import { HARDWARE_TRADE_IN_SUMMARY_TILE } from '../container/TradeIn/constants';
import { IActions, StateProps } from 'app/container/TradeIn/interface';
import { getDeviceWithId } from '../container/TradeIn/helpers/getDeviceWithId';
import { getDeviceFromStorage } from '../container/TradeIn/helpers/getDeviceFromStorage';
import replaceCMSPlaceholder from '../helpers/replaceCMSPlaceholder';

/**
 * Summary tile component
 * @param container
 */
export const mountTradeInSummaryTile = ({ deleteSelectedDevice }: IActions): SummaryTile => {
    const container = document.getElementById(HARDWARE_TRADE_IN_SUMMARY_TILE);

    return container && createSummaryTileComponent(container, {
        onClick: () => {
            deleteSelectedDevice();
        },
    });
};

/**
 * Update summary Tile
 *
 * @param summaryTileElement
 * @param state
 */
export const updateTradeInSummaryTile = (summaryTileElement: SummaryTile, state: Partial<StateProps>): void => {
    const deviceFromStorage = getDeviceFromStorage();
    const selectedDevice = (deviceFromStorage && deviceFromStorage.id) ? deviceFromStorage : getDeviceWithId(state.payload, state.selectedDeviceId);

    if (!selectedDevice) {
        return;
    }

    const summaryTileProperties = summaryTileElement.getProperties();
    const tradeInOptions = (window as any).additionalPageOptions?.promos?.tradeIn;
    const tauschbonusOptions = (window as any).additionalPageOptions?.promos?.tauschbonus;
    let tauschbonusDescription;
    if (tauschbonusOptions) {
        tauschbonusDescription = tauschbonusOptions && tauschbonusOptions.tauschbonusSubline;
        tauschbonusDescription = replaceCMSPlaceholder(tauschbonusDescription || '', { tauschbonusValue: tauschbonusOptions.tauschbonusValue});
    }
    let cmsSublines = tradeInOptions?.summaryTileSubline;
    if (tauschbonusDescription) {
        cmsSublines = cmsSublines.concat('<br>', tauschbonusDescription);
    }
    const subline = replaceCMSPlaceholder(cmsSublines || '', { maxPrice: selectedDevice.formattedPrice });

    const newSummaryTileProperties = {
        ...summaryTileProperties,
        imgSrc: selectedDevice.imgSrc,
        headline: {
            ...summaryTileProperties.headline,
            stdContent: selectedDevice.name,
        },
        sublines: [
            `<p>${subline}</p>`,
        ],
    };

    summaryTileElement.update(newSummaryTileProperties);
};
